import React, {useEffect, useRef, useState} from 'react';

import './styles';

interface CountdownProps {
  time?: number;
  text?: string;
  onStop?: () => void;
}

const DEFAULT_TIME = 30;
const SECOND = 1000;

const Countdown: React.FC<CountdownProps> = ({
  time = DEFAULT_TIME,
  text,
  onStop,
}) => {
  const [currentTime, setCurrentTime] = useState(time);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentTime(prev => Math.max(prev - 1, 0));
    }, SECOND);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (currentTime === 0 && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      onStop?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime]);

  return (
    <section className="countdown-container">
      {text && <span className="text">{text}</span>}
      {!!currentTime && <span className="text">{currentTime}</span>}
    </section>
  );
};

export default Countdown;
